import { IMAGE_FIT } from '@app/core/cms-flex/types';

import { MediaFit } from '../types';

export const IMAGE_CONTENT_FIT = new Map<IMAGE_FIT, MediaFit>()
  .set(IMAGE_FIT.DEFAULT, 'media-fit--default')
  .set(IMAGE_FIT.FULL, 'media-fit--full');
